import Axios from "axios";

class PessoaDataService {
  getAll() {
    return Axios.get("pessoas");
  }

  getPage(params) {
    return Axios.get("pessoas/page", { params });
  }

  getFilterPage(payload, params) {
    return Axios.post("pessoas/filter/page", payload, { params });
  }

  create(params) {
    return Axios.post("pessoas", params);
  }

  update(params) {
    return Axios.put("pessoas/" + params.id, params);
  }

  updateMyEmail(params) {
    return Axios.put("pessoas/myEmail", params);
  }

  updateMyPhone(params) {
    return Axios.put("pessoas/myPhone", params);
  }

  find(id) {
    return Axios.get(`pessoas/${id}`);
  }

  delete(id) {
    return Axios.delete(`pessoas/${id}`);
  }
}

export default new PessoaDataService();
